import type { FlowNodeData } from '$/domains/workFlowV3/type';

/**
 * 判断节点是否为特效模板 result 节点。
 * 优先看 isEffectNode；兼容旧数据时回退到 effectInputRules。
 */
export function isEffectTemplateNodeData(data?: FlowNodeData | null): boolean {
  if (!data) return false;
  if (data.isEffectNode === true) return true;
  return Array.isArray(data.effectInputRules) && data.effectInputRules.length > 0;
}
